
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useToast } from "@/components/ui/use-toast";
import { supabase } from "@/integrations/supabase/client";

interface PaymentData {
  houseId: string;
  description: string;
  expenseIds: string[];
  totalAmount: number;
}

export const usePaymentCreation = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();
  const navigate = useNavigate();

  const createPayment = async (data: PaymentData) => {
    if (!data.houseId) {
      toast({
        title: "Error",
        description: "Debe seleccionar una casa",
        variant: "destructive",
      });
      return;
    }

    if (data.expenseIds.length === 0) {
      toast({
        title: "Error",
        description: "Debe seleccionar al menos un gasto",
        variant: "destructive",
      });
      return;
    }

    const paymentDate = new Date().toISOString().split('T')[0];
    const paymentLinkUrl = `https://fintoc.me/condominioarrayan/${data.totalAmount}`;

    setIsSubmitting(true);

    try {
      const { data: paymentData, error } = await supabase
        .from('payments')
        .insert({
          house_id: data.houseId,
          amount: data.totalAmount.toString(),
          description: data.description,
          payment_date: paymentDate,
          expense_ids: data.expenseIds,
          payment_link_url: paymentLinkUrl
        })
        .select();

      if (error) throw error;

      toast({
        title: "Éxito",
        description: "Cobro creado correctamente",
      });

      // Navigate to payments page
      navigate('/payments');
    } catch (error) {
      console.error('Error creating payment:', error);
      toast({
        title: "Error",
        description: "No se pudo crear el cobro",
        variant: "destructive",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    createPayment,
    isSubmitting
  };
};
